module.exports = __webpack_public_path__ + "static/media/PB_G_02.e633bd12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_02.png
// module id = 215
// module chunks = 0